import React from "react"

export default function Moon({ style }) {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 41.54 55.91"
    >
      <path
        fill="#fff1bf"
        className="moon"
        d="M41.54,52.66A28.34,28.34,0,1,1,21.81,0,28.34,28.34,0,0,0,35,53.42,28.74,28.74,0,0,0,41.54,52.66Z"
      />
    </svg>
  )
}
